import React from 'react';

const Updates = () => {
  return (
    <div>
      <div id="mc_embed_signup" style={{ marginBottom: "22px" }}>
        <form
          action="https://seanhan.us17.list-manage.com/subscribe/post?u=a447a45d7f0753699efbe9f5b&amp;id=1453602455"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div style={{ display: "flex" }} id="mc_embed_signup_scroll">
            <input
              style={{ width: "75%" }}
              type="email"
              name="EMAIL"
              className="required email ant-input ant-input-lg"
              placeholder="Enter your email address"
              id="mce-EMAIL"
            />
            <div id="mce-responses" className="clear">
              <div
                className="response"
                id="mce-error-response"
                style={{ display: "none" }}
              />
              <div
                className="response"
                id="mce-success-response"
                style={{ display: "none" }}
              />
            </div>
            <div
              style={{ position: "absolute", left: "-5000px" }}
              aria-hidden="true"
            >
              <input
                type="text"
                name="b_a447a45d7f0753699efbe9f5b_1453602455"
                tabIndex="-1"
                value=""
              />
            </div>
            <div className="clear">
              <input
                style={{
                  marginTop: "2px",
                  backgroundColor: "#4353ff",
                  borderColor: "#4353ff",
                  marginLeft: "10px"
                }}
                type="submit"
                value="SUBSCRIBE"
                name="subscribe"
                id="mc-embedded-subscribe"
                className="button ant-btn ant-btn-primary"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Updates;


// WEBPACK FOOTER //
// ./src/steps/welcome/Updates.js